import LogoS from "@/assets/logo-s.svg";
import { cn } from "@/lib/utils";

const sizeStyles = {
  md: {
    container: "h-48",
    title: "line-clamp-3 text-xl 2xl:!text-2xl font-medium !leading-[150%] !text-white",
    logo: "w-16",
    padding: "p-6 md:p-8",
  },
  lg: {
    container: "h-64 md:h-96",
    title: "h1 line-clamp-4 font-medium leading-[150%]! text-white!",
    logo: "w-24",
    padding: "p-6 md:p-8 lg:px-12 lg:py-10",
  },
};

export default function ArticleCoverHeader({ title, as: Heading = "h2", size = "md", className, titleClassName, tinaField }) {
  const styles = sizeStyles[size] ?? sizeStyles.md;

  return (
    <div className={cn("relative bg-primary", styles.container, className)}>
      <div className={cn("overflow-hidden", styles.padding)}>
        <Heading {...(tinaField ? { "data-tina-field": tinaField } : {})} className={cn(styles.title, titleClassName)}>
          {title}
        </Heading>
      </div>
      <LogoS className={cn("absolute bottom-4 right-4 h-auto text-white/10!", styles.logo)} aria-hidden="true" />
    </div>
  );
}
